import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import Constraint from 'js/components/Constraint';
import Modal from 'js/components/core/Modal';

import StepMessage from 'js/components/core/SteppedPage/StepMessage';
import Title from 'js/components/core/SteppedPage/Title';
import StepStatus from 'js/components/core/SteppedPage/StepStatus';
import ProgressRow from 'js/components/core/SteppedPage/ProgressRow';
import ContinueButton from 'js/components/core/SteppedPage/ContinueButton';
import Backdrop from 'js/components/core/Backdrop';
import AddButton from 'js/components/core/SteppedPage/AddButton';

import Form from './Form';
import Display from './Display';
import SubTitle from './SubTitle';
import WhyPaymentMethodNeeded from 'js/components/core/WhyPaymentMethodNeeded';

import NewBankAccount from 'js/components-v2/pages/NewBankAccount';
import AppUser from 'js/stores/AppUser';
import UserCountry from 'js/services/UserCountry';

@inject('page')
@observer
export default class PaymentMethod extends Component {
  render() {
    const page = this.props.page;
    const showDisplay = page.credit_card.isFilledIn || page.bank_account.isFilledIn;

    return (
      <>
        <Backdrop>
          <Constraint>
            <Title>Payment method</Title>
            <SubTitle>You won’t be charged until you’ve received your item.</SubTitle>
          </Constraint>

          <Constraint>
            {showDisplay ? (
              <Display />
            ) : (
              <AddButton autoFocus onClick={page.openModal}>
                {AppUser.address?.country === 'NG' ? (
                  'Add bank account'
                ) : (
                  'Add payment method'
                )}
              </AddButton>
            )}

            <ProgressRow>
              <ContinueButton autoFocus={showDisplay} onClick={page.nextStep} />
            </ProgressRow>

            <StepMessage>You won't be charged yet</StepMessage>
            <StepStatus />
          </Constraint>
        </Backdrop>

        <WhyPaymentMethodNeeded />

        <Modal showModal={page.modalIsVisible} onCancel={page.closeModal} withCloseButton>
          {UserCountry() === 'NG' ? (
            <NewBankAccount page={page} />
          ) : (
            <Form />
          )}
        </Modal>
      </>
    );
  }
}
